<template>
    <div class="container" id="contact_form">
        <h5><b><i class="far fa-envelope"></i> Kontaktujte nás</b></h5>
        <form>
            <div class="form-group">
                <input type="text" ref="name" class="form-control" v-bind:class="{ input_err: name_error }" placeholder="Meno" @change="checkOnlyName()">
            </div>
            <div class="form-group">
                <input type="email" ref="email" class="form-control" v-bind:class="{ input_err: email_error }" placeholder="Email" @change="checkOnlyMail()">
            </div>
            <div class="form-group">
                <textarea ref="text" class="form-control" rows="4" v-bind:class="{ input_err: text_error }" placeholder="Správa" @change="checkOnlyText()"></textarea>
            </div>
            <vue-recaptcha 
                ref="recaptcha"
                sitekey="6LcUBuQUAAAAAIdXQ8Ln8zzanWRVLX1-dn9ZUL2o"
                @verify="onVerify"
                @expired="onExpired"
                theme="dark"
                style="margin-bottom: 16px">
            </vue-recaptcha>
            <p class="error_msg" v-if="!send_status && not_first_time">Nepodarilo sa odoslať kontaktný formulár!</p>
            <p class="success_msg" v-if="send_status">Kontaktný formúlár bol úspešne odoslaný.</p>
            <div class="form-group">
                <button type="submit" class="custom_button" @click.prevent="getFormValues()">Odoslať</button>
            </div>
        </form>
    </div>
</template>
<script>
    import axios from 'axios';
    import VueRecaptcha from 'vue-recaptcha';

    export default {
        name: "ContactForm",
        data() {
            return {
                name_error: Boolean,
                email_error: Boolean,
                text_error: Boolean,
                send_status: Boolean
            }
        },
        created() {
                this.name_error = false;
                this.email_error = false;
                this.text_error = false;
                this.captcha_status = false;
                this.send_status = false;
                this.not_first_time = false;
        },
        methods: {
            checkForm: function (data) {
                this.name_error = false;
                this.email_error = false;
                this.text_error = false;

                if (!data.name.value) {
                    this.name_error = true;
                }
                if (!data.email.value || !this.checkEmail(data.email.value)) {
                    this.email_error = true;
                }
                if (!data.text.value) {
                    this.text_error = true;
                }

                if (!this.name_error && !this.email_error && !this.text_error) {
                    return true;
                }
                return false;
            },
            afterMailSent: function() {                
                this.$refs.name.value = "";
                this.$refs.email.value = "";
                this.$refs.text.value = "";
                this.$refs.recaptcha.reset();
                this.not_first_time = true;
                console.log(this.send_status);
            },
            checkEmail: function (string) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(string);
            },
            checkOnlyName: function () {
                this.name_error = false;

                if (!this.$refs.name.value) {
                    this.name_error = true;
                    return true;
                }
                return false;
            },
            checkOnlyMail: function () {
                this.email_error = false;

                if (!this.$refs.email.value || !this.checkEmail(this.$refs.email.value)) {
                    this.email_error = true;
                    return true;
                }
                return false;
            },
            checkOnlyText: function () {
                this.text_error = false;

                if (!this.$refs.text.value) {
                    this.text_error = true;
                    return true;
                }
                return false;
            },
            onVerify: function (response) {
                console.log('Verify: ' + response);
                this.captcha_status = true;
            },
            onExpired: function () {
                console.log('Expired');
                this.captcha_status = false;
            },
            getFormValues: function (event) {
                console.log(this.$refs)
                if (this.checkForm(this.$refs) && this.captcha_status) {
                    var authOptions = {
                        method: 'POST',
                        headers: {
                            'Authorization': "Bearer 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",
                            'Content-Type': 'application/json'
                        },
                        url: 'https://cors-anywhere.herokuapp.com/https://api.sendgrid.com/v3/mail/send',
                        data: {
                            "personalizations": [
                                {
                                    "to": [ {"email": "monika.vitkova@zoznam.sk"} ],
                                    "subject": "Automatická správa z kontaktného formulára"
                                }
                            ],
                            "from": {
                                "email": this.$refs.email.value
                            },
                            "content": [
                                {
                                "type": "text/plain",
                                "value": this.$refs.text.value + "\n\n" + this.$refs.name.value
                                }
                            ]
                        }
                    };
                    axios(authOptions)
                    .then(response => {
                        console.log(response);
                        this.send_status = true;
                        console.log("Valid");
                        this.afterMailSent();
                    })
                    .catch(e => {
                        console.log(e);
                        this.send_status = false;
                        console.log("Not valid");
                        this.afterMailSent();
                    })
                } else {
                    this.send_status = false;
                    console.log("Not valid");
                    this.afterMailSent();
                }
            },
        },
        components: { VueRecaptcha }
        //curl -X "POST" "https://api.sendgrid.com/v3/mail/send" -H "Authorization: Bearer YOUR_API_KEY" -H "Content-Type: application/json" -d "[YOUR DATA HERE]"

    }
</script>

<style>
    #contact_form {
        padding: 0 30px;
    }
    #contact_form h5 i {
        margin-right: 5px;
    }
    #contact_form form {
        padding: 15px 0;
    }
    #contact_form form .form-group {
        padding: 10px 0;
    }
    #contact_form form .form-group:last-child {
        padding: 30px 0;
    }
    #contact_form form .form-group .form-control {
        border: none;
        border-radius: 0;
        padding: 10px 20px;
        background-color: rgba(255,255,255,0.2);
        color: #fff;
    }
    #contact_form form .form-group .form-control.input_err {
        border: 2px solid #E15C4D;
        color: #FD3629;
    }
    #contact_form form .form-group .form-control::placeholder {
        color: #999;
    }
    #contact_form form .form-group .form-control.input_err::placeholder {
        color: #E15C4D;
    }
    #contact_form form .custom_button {
        background-color: rgba(255,255,255,0.5);
        width: 95%;
    }
    #contact_form form .custom_button:hover {
        background-color: rgba(255, 255, 255, 0.8);
        width: 100%;
    }
    #contact_form .error_msg {
        text-align: center;
        color: #E15C4D;
    }    
    #contact_form .success_msg {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/ContactForm.vue